export default {
    REFUND: 'refund',
    UNBLOCK: 'unblock',
    CHARGE: 'charge',
    AUTHORIZE: 'authorize',
    ANTIFRAUD_RULES_VIEW : 'antifraud_rules_view',
    GEN_PAY_LINK: 'payment_link_generate',
    ANALYTIC: 'dashboard',
    REPORTS: 'reports',
    GEN_CSR: 'generate_csr',
    SHOW_BANK_LOGS: 'show_bank_logs',
    ACTUALIZE_TRANSACTION_STATE: "actualize_transaction",
    FINANCE: 'finance'
}